/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Removed_ToastInputs */

const en_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag set removed successfully`)
};

const fr_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensemble de tags supprime avec succes`)
};

const de_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag-Set erfolgreich entfernt`)
};

const it_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il set di tag è stato rimosso correttamente`)
};

const ru_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Набор тегов успешно удален.`)
};

const es_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto de etiquetas eliminado correctamente`)
};

const zh_cn2_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签集已成功移除`)
};

const ja_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグセットが正常に削除されました`)
};

const hi_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग सेट सफलतापूर्वक हटा दिया गया`)
};

const pt_pt2_tags_manager_removed_toast = /** @type {(inputs: Tags_Manager_Removed_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conjunto de tags removido com sucesso`)
};

/**
* | output |
* | --- |
* | "Tag set removed successfully" |
*
* @param {Tags_Manager_Removed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_removed_toast = /** @type {((inputs?: Tags_Manager_Removed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Removed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_removed_toast(inputs)
	if (locale === "de") return de_tags_manager_removed_toast(inputs)
	if (locale === "it") return it_tags_manager_removed_toast(inputs)
	if (locale === "ru") return ru_tags_manager_removed_toast(inputs)
	if (locale === "es") return es_tags_manager_removed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_removed_toast(inputs)
	if (locale === "ja") return ja_tags_manager_removed_toast(inputs)
	if (locale === "hi") return hi_tags_manager_removed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_removed_toast(inputs)
	return en_tags_manager_removed_toast(inputs)
});